export default {
  "es-AR": "AR", // 阿根廷
  "es-MX": "MX", // 墨西哥
  "pt-BR": "BR", // 巴西
  "en-PH": "PH", // 菲律宾
  "zh-SG": "SG", // 新加坡
  es: "AR", // 阿根廷
  pt: "BR", // 巴西
  te: "IN", // 印度
  ta: "IN", // 印度
  id: "ID", // 印尼
  km: "KH", // 柬埔寨
  lo: "LA", // 老挝
  ms: "MY", // 马来西亚
  my: "MM", // 缅甸
  tl: "PH", // 菲律宾
  en: "SG", // 新加坡
  th: "TH" // 泰国
};
